module.exports = __webpack_public_path__ + "img/usuario-preenchido.02406e08.svg";